export const MAP_CONSTANTS = {
  TERRAIN_EXAGGERATION: 1.5,
  TERRAIN_MAXZOOM: 18,
  DEFAULT_CENTER: [-122.4384, 37.789] as [number, number],
  DEFAULT_ZOOM: 18,
  PATH_LINE_COLOR: '#F70000',
  PATH_LINE_WIDTH: 3,
  GIMBAL_OFFSET_PIP: 15,
  GIMBAL_OFFSET_NORMAL: 50,
  FLY_TO_SPEED_FAST: 5.0,
  FLY_TO_SPEED_SLOW: 0.3,
  FLY_TO_CURVE: 1.2,
  FLY_TO_DISTANCE_THRESHOLD: 0.1,
  FLY_TO_BOUNDS_PADDING: 0.1,
  USER_ZOOM_WAIT_MS: 9000,
  ELEVATION_PRELOAD_DEBOUNCE_MS: 2000,
  ELEVATION_PRELOAD_MIN_BOUNDS_CHANGE: 0.005,
  ELEVATION_PRELOAD_MAX_TILES: 12,
  ELEVATION_PRELOAD_BUFFER_TILES: 1,
  ELEVATION_PRELOAD_RADIUS_METERS: 100,
  ARROW_MARKER_SIZE: 30
} as const;

export const DEG_TO_RAD = Math.PI / 180;
export const RAD_TO_DEG = 180 / Math.PI;
export const FULL_CIRCLE_DEG = 360;
export const GIMBAL_ROTATION_OFFSET = 180;
